import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingCart, Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import ContactFormModal from "./ContactFormModal";

const Footer = () => {
  const [showContactModal, setShowContactModal] = useState(false);

  return (
    <>
    <footer className="bg-slate-900 text-slate-300" data-testid="footer">
      <div className="container-main py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-sky-500 to-blue-600 flex items-center justify-center">
                <ShoppingCart className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold text-white font-['Outfit']">BundleCart</span>
            </div>
            <p className="text-sm text-slate-400">
              One cart. Multiple stores. One delivery plan.
            </p>
            <p className="text-xs text-slate-500">
              Compare prices across retail stores.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/products" className="hover:text-sky-400 transition-colors">
                  Browse Products
                </Link>
              </li>
              <li>
                <Link to="/cart" className="hover:text-sky-400 transition-colors">
                  Shopping Cart
                </Link>
              </li>
              <li>
                <Link to="/orders" className="hover:text-sky-400 transition-colors">
                  Track Orders
                </Link>
              </li>
              <li>
                <Link to="/account" className="hover:text-sky-400 transition-colors">
                  My Account
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-white font-semibold mb-4">Support</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button
                  onClick={() => setShowContactModal(true)}
                  className="flex items-center gap-2 hover:text-sky-400 transition-colors cursor-pointer"
                  data-testid="footer-contact-us"
                >
                  <MessageCircle className="w-4 h-4" />
                  <span>Contact Us</span>
                </button>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4" />
                <span>support@bundlecart.au</span>
              </li>
              <li className="text-slate-400 text-xs">
                Email support within 24 hours
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4">Important Info</h4>
            <ul className="space-y-2 text-xs text-slate-400">
              <li>
                We display publicly listed prices, last checked at the time shown.
              </li>
              <li>
                We are not affiliated with listed retailers.
              </li>
              <li>
                Prices may change at checkout.
              </li>
              <li className="pt-2">
                <span className="text-slate-500">ABN: 15 923 035 074</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} BundleCart Pty Ltd. All rights reserved.
          </p>
          <div className="flex gap-4 text-xs text-slate-500">
            <Link to="/privacy" className="hover:text-slate-300 transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-slate-300 transition-colors">Terms of Service</Link>
            <Link to="/refund" className="hover:text-slate-300 transition-colors">Refund Policy</Link>
          </div>
        </div>
      </div>
    </footer>

    {/* Contact Form Modal */}
    <ContactFormModal
      isOpen={showContactModal}
      onClose={() => setShowContactModal(false)}
    />
    </>
  );
};

export default Footer;
